define('modules/resolution/main/views/resolve.person.view',[
    'client',
    'jquery',
    'jqueryUi',
    'underscore',
    'backbone',
    'marionette',
    'modules/base/views/model.view',
    'modules/resolution/models/concord.individual.model',
    'text!modules/resolution/main/templates/resolve.person.template.html'
], function(Prospector,$, jqueryUi, _,Backbone,
            Marionette,
            ModelView,
            ConcordIndividualModel,
            Template) {
    var ResolvePersonView = ModelView.extend({
        template: _.template(Template),
        className: 'resolvePersonView row',
        mainBtnLoaderRestingText: 'Search',
        mainBtnLoaderWorkingText: 'Searching',
        mEvents:function(){
          return {
              'keyup .filterInput' : 'procFilterInput',
              'click .resetBtn': 'procResetBtn'
          }
        },
        initialize: function(options){
            this.buildModel();
        },
        buildModel:function(){
            this.model = new ConcordIndividualModel();
            this.mode = 'save';
        },
        onRender:function(){
            this.$(this.mainBtnLoaderTextSelector).html(this.mainBtnLoaderRestingText);
            if(window.location.hash.indexOf("?") > -1){
                var query = window.location.hash.split("?")[1];
                var firstName = window.utils.getQueryStringParameter(query, "firstName");
                var lastName = window.utils.getQueryStringParameter(query, "lastName");
                var company = window.utils.getQueryStringParameter(query, "company");
                var emailDomain = window.utils.getQueryStringParameter(query, "emailDomain");

                company = decodeURIComponent(company);
                firstName = decodeURIComponent(firstName);
                lastName = decodeURIComponent(lastName);

                this.$('.firstName').val(firstName);
                this.$('.lastName').val(lastName);
                this.$('.company').val(company);
                this.$('.emailDomain').val(emailDomain);
                this.mainBtn();
            }
        },
        setModel:function(firstName, lastName, company, emailDomain){

            this.model.set({
                "contactId": "",
                "minimumScore": 90,
                "firstNames": [
                    firstName
                ],
                "middleNames": [
                    ""
                ],
                "nickNames": [
                    ""
                ],
                "lastNames": [
                    lastName
                ],
                "roles": [
                    {
                        "company": company,
                        "title": ""
                    }
                ],
                "emails": [
                    {
                        "email": "",
                        "username": "",
                        "domain": emailDomain,
                        "usernameHash": "",
                        "emailHash": ""
                    }
                ],
                "addresses": [
                    {
                        "addressLine1": "",
                        "addressLine2": "",
                        "city": "",
                        "state": "",
                        "country": "",
                        "zipcode": ""
                    }
                ]
            });
        },
        procMainBtn:function(){
            var firstName = this.$('.firstName').val();
            var lastName = this.$('.lastName').val();
            var company = this.$('.company').val();
            var emailDomain = this.$('.emailDomain').val();
            var hasError = false;

            if(firstName == ""){
                this.errOut("First name cannot be blank.");
                hasError = true;
            } else if(lastName == ""){
                this.errOut("Last name cannot be blank.");
                hasError = true;
            } else if(company == "" && emailDomain==""){
                this.errOut("Both company name and email domain cannot be blank.");
                hasError = true;
            }

            if(hasError){
                this.removeMainBtnLoader();
            } else {
                this.setModel(firstName, lastName, company, emailDomain);
                this.listenToOnce(this.model, 'sync', this.mainBtnResponse, this);
                this.fetchModel();
            }
        },
        procMainBtnResponse:function(){
            Prospector.trigger('closeSideDrawer');
            if(this.model.isValid()){
                if(this.model.get('relproId') == 0){
                    var fname= this.model.get('firstNames')[0];
                    var lname= this.model.get('lastNames')[0];
                    var company=this.model.get('roles')[0].company;
                    Prospector.trigger("dashboard", true);
                    window.setTimeout(function(){
                        $(".searchViewHolder").show();
                        $("#searchToggle").bootstrapSwitch('state', true);
                        $(".searchBar").eq(0).val(fname);
                        $(".searchBar").eq(1).val(lname);
                        $(".searchBar").eq(2).val(company);
                        $(".searchBtn").click();
                    }, 4000);
                } else {
                    var that = this;
                    window.setTimeout(function(){
                        Prospector.navigate("#profile/person/100/" + that.model.get('relproId'), true);
                    }, 1000);
                }
            } else {
                this.errOut(this.model.errorMessage);
            }
        },
        procFilterInput:function(event){
            event.stopPropagation();
            var inp = String.fromCharCode(event.keyCode);
            if(event.keyCode == 13){
                this.mainBtn();
            }
        },
        procResetBtn:function(){
            this.$('.filterInput').val('');
        }
    });
    return ResolvePersonView;
});
